
import { NavLink, Indicator } from '@mantine/core';
import { Link, useLocation } from 'react-router-dom';
import { ConfigContext, MyUserDataContext } from '../contexts';
import { ClaimType, CustomClaims, KYCStatusCode, OrderStatusCode, ServiceStatusCode, ServiceType, TradeDate, TransactionStatusCode } from '../types';
import { collection, collectionGroup, doc, getDoc, limit, onSnapshot, orderBy, query, where, getCountFromServer } from 'firebase/firestore';
import { useContext, useEffect, useState } from 'react';
import { useFirestore } from '../helpers/firebaseContext';
import { routesList } from '../App';
import { getPortfolioPendingStatusesForClaims } from '../helpers/serviceStatusFilters';
import { getPendingTradeDates } from '../routes/trades/trades_permissions';
import { resolveAvailableRouteKeys } from '../helpers/routeAccess';





export interface NavigationBarType {

  to: string,
  showfor?: ClaimType[]
  icon: JSX.Element
  label: string,
}


export function MainLinks() {
  const db = useFirestore();
  const [pendingOrders, setPendingOrders] = useState(0)
  const [pendingTransactions, setPendingTransactions] = useState(0)
  const [pendingServices, setPendingServices] = useState(0)
  const [pendingPortfolios, setPendingPortfolios] = useState(0)
  const [pendingManualRequests, setPendingManualRequests] = useState(0)
  const [pendingCustomers, setPendingCustomers] = useState(0)
  const [whatsappUnread, setWhatsappUnread] = useState(0)
  const [whatsappUnreadCapped, setWhatsappUnreadCapped] = useState(false)
  const [ctcWaiting, setCtcWaiting] = useState(0)
  const [ctcWaitingCapped, setCtcWaitingCapped] = useState(false)
  const [pendingTradeDates, setPendingTradeDates] = useState(0)
  const [routes, setRoutes] = useState<any>([])
  // const [pendingCustomers, setPendingCustomers] = useState(0)
  const userData = useContext(MyUserDataContext);
  const configData = useContext(ConfigContext);

  let customClaims = userData.firebaseTokenResult?.claims.customClaims as CustomClaims;
  const routePermissions = configData?.routesPermissions;


  // const routes: any = [];
  useEffect(() => {

    const orderStatuses: string[] = []


    if (customClaims["rm"] === true) {
      orderStatuses.push(OrderStatusCode.need_slip, OrderStatusCode.need_form)

    }
    if (customClaims["cr"] === true) {
      orderStatuses.push(...[OrderStatusCode.review, OrderStatusCode.approval, OrderStatusCode.waiting_for_kyc])

    }
    if (customClaims["oper"] === true) {
      orderStatuses.push(...[OrderStatusCode.processing, OrderStatusCode.waiting_for_nav])

    }


    if (orderStatuses.length) {
      const orderQuery = query(collectionGroup(db, "orders"), where('tags.orderStatus.code', 'in', orderStatuses))
      const fetchCount = () => {
        getCountFromServer(orderQuery)
          .then((snapshot) => setPendingOrders((snapshot.data() as any)?.count || 0))
          .catch(() => setPendingOrders(0))
      }
      fetchCount();
      const intervalId = window.setInterval(fetchCount, 60 * 60 * 1000);
      return () => window.clearInterval(intervalId);
    }


    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [customClaims]);
  useEffect(() => {

    const serviceStauses: string[] = []
    const mainServiceTypes: ServiceType[] = ["kfhtrade", "ipo"];


    if (customClaims["cr"] === true) {
      serviceStauses.push(...[ServiceStatusCode.authorized_signatory_approval, ServiceStatusCode.waiting_for_kyc, ServiceStatusCode.waiting_for_execution, ServiceStatusCode.need_iban])

    }

    if (serviceStauses.length) {
      const fetchCount = () => {
        Promise.all(
          mainServiceTypes.map((serviceType) => getCountFromServer(
            query(
              collectionGroup(db, "services"),
              where('tags.serviceStatus.code', 'in', serviceStauses),
              where('serviceType', '==', serviceType)
            )
          ))
        )
          .then((snapshots) => setPendingServices(
            snapshots.reduce((total, snapshot) => total + ((snapshot.data() as any)?.count || 0), 0)
          ))
          .catch(() => setPendingServices(0))
      }
      fetchCount();
      const intervalId = window.setInterval(fetchCount, 60 * 60 * 1000);
      return () => window.clearInterval(intervalId);
    }

  }, [customClaims])

  useEffect(() => {

    const serviceStatuses = getPortfolioPendingStatusesForClaims(customClaims);

    if (serviceStatuses.length) {
      const portfoliosQuery = query(
        collectionGroup(db, "services"),
        where('tags.serviceStatus.code', 'in', serviceStatuses),
        where('serviceType', '==', 'portfolio')
      )
      const fetchCount = () => {
        getCountFromServer(portfoliosQuery)
          .then((snapshot) => setPendingPortfolios((snapshot.data() as any)?.count || 0))
          .catch(() => setPendingPortfolios(0))
      }
      fetchCount();
      const intervalId = window.setInterval(fetchCount, 60 * 60 * 1000);
      return () => window.clearInterval(intervalId);
    }

    setPendingPortfolios(0);

  }, [customClaims])

  useEffect(() => {

    if (customClaims["cr"] === true) {
      const transactionsQuery = query(collectionGroup(db, "transactions"), where('tags.transactionStatus.code', '==', TransactionStatusCode.approval))
      const fetchCount = () => {
        getCountFromServer(transactionsQuery)
          .then((snapshot) => setPendingTransactions((snapshot.data() as any)?.count || 0))
          .catch(() => setPendingTransactions(0))
      }
      fetchCount();
      const intervalId = window.setInterval(fetchCount, 60 * 60 * 1000);
      return () => window.clearInterval(intervalId);
    }

    setPendingTransactions(0);

  }, [customClaims])

  useEffect(() => {
    const kycStatuses: string[] = []


    if (customClaims["cr"] === true) {

      kycStatuses.push(...[KYCStatusCode.review, KYCStatusCode.approval, KYCStatusCode.exec_approval])

    }

    if (kycStatuses.length) {
      const customersQuery = query(collection(db, "customers"), where('tags.kycStatus.code', 'in', kycStatuses))
      const fetchCount = () => {
        getCountFromServer(customersQuery)
          .then((snapshot) => setPendingCustomers((snapshot.data() as any)?.count || 0))
          .catch(() => setPendingCustomers(0))
      }
      fetchCount();
      const intervalId = window.setInterval(fetchCount, 60 * 60 * 1000);
      return () => window.clearInterval(intervalId);
    }
  }, [customClaims])

  useEffect(() => {
    if (routePermissions) {
      const customArrayRoutes = resolveAvailableRouteKeys(routePermissions, customClaims);
      const newRoutes = customArrayRoutes.map((routeKey: string) => routesList[routeKey]).flat();
      setRoutes(newRoutes);

    }
  }, [customClaims, routePermissions])

  useEffect(() => {
    //live unread total for the WhatsApp inbox; rules only allow cr/admin to read the collection.
    //capped at 50 threads so every open portal tab isn't streaming an unbounded
    //snapshot if unread conversations ever pile up — past the cap we show "N+"
    if (customClaims["cr"] === true || customClaims["admin"] === true) {
      const UNREAD_THREADS_CAP = 50;
      const unreadQuery = query(collection(db, "whatsapp_threads"), where("unreadCount", ">", 0), limit(UNREAD_THREADS_CAP));
      return onSnapshot(unreadQuery,
        (snapshot) => {
          setWhatsappUnread(snapshot.docs.reduce((total, threadDoc) => total + (threadDoc.data().unreadCount || 0), 0));
          setWhatsappUnreadCapped(snapshot.size >= UNREAD_THREADS_CAP);
        },
        () => setWhatsappUnread(0),
      );
    }
    setWhatsappUnread(0);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [customClaims])

  useEffect(() => {
    //CTC: live count of purchase orders waiting on one of the user's lanes (same query as the
    //CTC watch list; KFH users are scoped to their customer as the rules require). Capped so an
    //open tab never streams an unbounded snapshot — past the cap we show "N+".
    const claims = (customClaims ?? {}) as CustomClaims;
    const lanes: string[] = [];
    if (claims.ctc_maker) lanes.push("maker");
    if (claims.ctc_checker) lanes.push("checker");
    if (claims.ctc_supervisor) lanes.push("supervisor");
    if (claims.ctc_dealer) lanes.push("dealer", "beneficiary");
    if (lanes.length && claims.routeGroups?.includes("ctc")) {
      const CTC_WAITING_CAP = 99;
      const scope = claims.ctc_customer_id ? [where("customerId", "==", claims.ctc_customer_id)] : [];
      const waitingQuery = query(collection(db, "ctc_purchase_orders"), ...scope, where("lane", "in", lanes), orderBy("created", "asc"), limit(CTC_WAITING_CAP));
      return onSnapshot(waitingQuery,
        (snapshot) => {
          setCtcWaiting(snapshot.size);
          setCtcWaitingCapped(snapshot.size >= CTC_WAITING_CAP);
        },
        () => setCtcWaiting(0),
      );
    }
    setCtcWaiting(0);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [customClaims])

  useEffect(() => {
    //live count of trade dates with pending work, scoped per role: ops/admin see
    //allocation + Geneva-send backlog across all accounts; trading teams see only
    //their own accounts' unallocated trades (sending is not their job).
    //Full-collection scan so the badge always matches the trades/ops pages, which
    //load every trade_dates doc anyway (small docs, one per trading day).
    const isOps = customClaims["admin"] === true || customClaims["oper"] === true;
    const tradeAccounts = userData.availableTradeAccounts ?? [];
    if (isOps || tradeAccounts.length > 0) {
      return onSnapshot(collection(db, "trade_dates"),
        (snapshot) => {
          const record: Record<string, TradeDate> = {};
          snapshot.forEach((dateDoc) => { record[dateDoc.id] = dateDoc.data() as TradeDate; });
          const rows = getPendingTradeDates(record, isOps ? null : tradeAccounts);
          // Count only allocation-pending dates so the badge matches the trades page
          // it opens (the ops page still shows the full send backlog in its own panel).
          setPendingTradeDates(rows.filter((r) => r.unallocated > 0).length);
        },
        () => setPendingTradeDates(0),
      );
    }
    setPendingTradeDates(0);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [customClaims, userData.availableTradeAccounts])

  useEffect(() => {
    if (customClaims["cr"] === true) {

      const documentRef = doc(db, 'manual/consent');

      // converters are used with `setDoc`, `addDoc`, and `getDoc`
      getDoc(documentRef).then(

        async (snapshotObj) => {

          setPendingManualRequests((snapshotObj.data())?.requires_approval?.length || 0);

        });
      return;
    }
  }, [customClaims])


  const location = useLocation();

  const sideBarRoutes = routes?.filter((routeObj: any) => routeObj?.sideBar)?.sort((a: any, b: any) => {
    if (a.order !== b.order) return a.order - b.order;
    return b.label.localeCompare(a.label);
  }) ?? [];

  // Only the most specific matching route is active, so nested links like
  // /customers/update_requests don't also highlight /customers.
  const routeMatches = (to: string) => to !== "/" && (location.pathname === to || location.pathname.startsWith(to + "/"));
  const activeRouteTo = sideBarRoutes
    .filter((routeObj: any) => routeMatches(routeObj.to))
    .sort((a: any, b: any) => b.to.length - a.to.length)[0]?.to;

  return <div>
    {sideBarRoutes.map((route: any, idx: any) => <NavLink
      key={idx}
      {...route}
      leftSection={
        route.to === "/orders" && pendingOrders ?
          <Indicator inline color='pink' label={pendingOrders} size={16}>
            {route.icon}
          </Indicator>

          :
          route.to === "/customers" && pendingCustomers ?
            <Indicator inline color='pink' label={pendingCustomers} size={16}>
              {route.icon}
            </Indicator>
            :
            route.to === "/services" && pendingServices ?
              <Indicator inline color='pink' label={pendingServices} size={16}>
                {route.icon}
              </Indicator> :
              route.to === "/portfolios" && pendingPortfolios ?
                <Indicator inline color='pink' label={pendingPortfolios} size={16}>
                  {route.icon}
                </Indicator> :
                route.to === "/manual" && pendingManualRequests ?
                  <Indicator inline color='pink' label={pendingManualRequests} size={16}>
                    {route.icon}
                  </Indicator> :

                  route.to === "/transactions" && pendingTransactions ?
                    <Indicator inline color='pink' label={pendingTransactions} size={16}>
                      {route.icon}
                    </Indicator> :
                    route.to === "/ctc" && ctcWaiting ?
                      <Indicator inline color='orange' label={ctcWaitingCapped ? `${ctcWaiting}+` : ctcWaiting} size={16}>
                        {route.icon}
                      </Indicator> :
                    route.to === "/whatsapp" && whatsappUnread ?
                      <Indicator inline color='green' label={whatsappUnreadCapped ? `${whatsappUnread}+` : whatsappUnread} size={16}>
                        {route.icon}
                      </Indicator> :
                      route.to === "/trades" && pendingTradeDates ?
                        <Indicator inline color='pink' label={pendingTradeDates} size={16}>
                          {route.icon}
                        </Indicator> :
                        route.icon}

      style={{
        fontSize: "1rem",

        fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Helvetica, Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji"'
      }}
      component={Link}
      active={route.to === activeRouteTo}
      color={import.meta.env.VITE_MAIN_COLOR ?? '#AA9F8E'} />)
    }






  </div>;
}
